export default __webpack_public_path__ + "static/media/arrow-up.450d83ee.svg";